import {Color} from '$constants/style';

export const containerStyles: React.CSSProperties = {
  backgroundColor: Color.SidebarMain,
  maxHeight: '100vh',
  width: '100%',
  overflow: 'auto',
  maxWidth: '100% !important',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: '12px 32px 24px',
  fontFamily: "'Inter Variable', sans-serif",
};

export const headerNameStyles = {
  color: Color.Purple600,
  fontWeight: 600,
  fontSize: '24px',
  padding: '12px 12px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  ml: '-12px',
};

export const contentWrapperStyles: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
};

export const backButtonStyles = {
  marginBottom: '8px',
  maxWidth: '80px',
  width: '100%',
  lineHeight: '22px',
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 400,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: Color.Purple600,
  '&:hover': {
    backgroundColor: Color.BackButtonBackground,
  },
};

export const headerTitleStyles = {
  color: Color.Purple600,
  fontWeight: 600,
  fontSize: '24px',
  padding: '16px 16px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const summaryContainerStyles = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '16px',
  padding: '12px 0 24px',
};

export const summaryBoxStyles = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  justifyContent: 'flex-start',
  minHeight: '80px',
  alignItems: 'flex-start',
  gap: '9px',
};

export const summaryLabelStyles = {
  color: Color.TextPrimary,
  fontSize: '14px',
  fontWeight: 400,
};

export const centeredSummaryValueStyles = {
  width: '100%',
  margin: 'auto 0',
};

export const summaryValueStyles = {
  color: Color.Grey500,
  fontSize: '32px',
  fontWeight: 600,
  ...centeredSummaryValueStyles,
};

export const summarySmallValueStyles = {
  color: Color.Grey500,
  fontSize: '16px',
  fontWeight: 600,
  ...centeredSummaryValueStyles,
};

export const verticalDividerStyles = {
  borderColor: Color.Grey300,
  margin: '16px 0',
};

export const paymentMethodContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  ...centeredSummaryValueStyles,
  '& svg': {
    width: '18px',
    height: '18px',
  },
};

export const chequeIconStyles = {
  color: Color.Black,
};

export const cardIconStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '& svg': {
    width: '70px',
    height: '36px',
  },
};

export const sectionTitleStyles = {
  fontSize: '24px',
  fontWeight: 600,
  color: Color.Purple600,
  marginBottom: 0.5,
  lineHeight: '28px',
  padding: '8px 0 8px',
};

export const detailsContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: '16px',
  minHeight: '120px',
};

export const detailsLabelStyles = {
  fontSize: '14px',
  fontWeight: 400,
  color: Color.TextPrimary,
  minWidth: '120px',
};

export const actionButtonStyles = {
  gap: 1,
  display: 'flex',
  marginLeft: '32px',
  '& > button': {
    minWidth: '32px',
    width: '32px',
    height: '32px',
  },
};

export const detailsValueStyles = {
  fontSize: '16px',
  fontWeight: 400,
  color: Color.Grey500,
};

export const descriptionValueStyles = {
  ...detailsValueStyles,
  wordBreak: 'break-word',
  whiteSpace: 'pre-wrap',
};

export const editButtonStyles = {
  width: '40px',
  height: '40px',
  p: 0,
  flexShrink: 0,

  '&:hover': {
    backgroundColor: 'transparent',
  },
};

export const detailsRowStyles = {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  marginRight: '390px',
};

export const detailsListStyles = {
  display: 'flex',
  flexDirection: 'column',
};

export const dialogTextFieldStyles = {
  mb: 3,
};

export const dialogActionsStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 2,
};

export const PaymentDetailsButtonsWrapperStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '16px',
};

export const GenerateInvoiceButtonWrapperStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  margin: '0 20px 20px 0',
  backgroundColor: Color.White,
};

export const GenerateInvoiceButtonStyles = {
  textTransform: 'none',
  color: `${Color.Purple600} !important`,
  border: '1px solid #ccc !important',
  backgroundColor: `${Color.White} !important`,
  '&:hover': {
    backgroundColor: `${Color.White} !important`,
    border: '1px solid #ccc !important',
  },
  '&.MuiButton-outlined': {
    backgroundColor: `${Color.White} !important`,
    '&:hover': {
      backgroundColor: `${Color.White} !important`,
    },
  },
};

export const roundedTextFieldStyles = {
  '& .MuiOutlinedInput-root': {borderRadius: '8px'},
};

export const dialogBodyStyles = {
  p: 2,
  display: 'flex',
  flexDirection: 'column',
};

export const dialogTitleStyles = {
  color: '#000',
  fontWeight: 700,
  fontSize: '24px',
  ml: 0,
  mb: 1,
};

export const dialogNoteStyles = {
  color: Color.Grey400,
  fontSize: '14px',
  lineHeight: '20px',
  margin: 0,
};

export const formFieldContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
};

export const formFieldLabelStyles = {
  mb: 1,
  color: Color.Grey500,
  fontSize: '0.875rem',
};

export const selectStyles = {
  '& .MuiOutlinedInput-root': {borderRadius: '8px'},
};

export const dialogActionsContainerStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 2,
  mt: 2,
};

export const currencyAdornmentStyles = {
  className: 'mr-1',
};

export const refundDialogStyles = {
  '& .MuiDialog-paper': {
    overflow: 'visible !important',
  },
};

export const paymentLinkModalStyles = {
  '& .MuiDialog-paper': {
    maxWidth: '520px',
    width: '100%',
    borderRadius: '16px',
    boxShadow: `0px 20px 25px -5px ${Color.Black}1A, 0px 10px 10px -5px ${Color.Black}0A`,
  },
};

export const paymentLinkFieldStyles = {
  position: 'relative',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  '& .MuiTextField-root': {
    width: '75%',
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      backgroundColor: Color.Grey50,
      border: `1px solid ${Color.Grey300}`,
      width: '100%',
      cursor: 'not-allowed',
      '&:hover': {
        border: `1px solid ${Color.Grey300}`,
      },
      '&.Mui-focused': {
        border: `1px solid ${Color.Grey300}`,
        boxShadow: 'none',
      },
    },
    '& .MuiOutlinedInput-input': {
      fontSize: '14px',
      lineHeight: '20px',
      color: Color.Grey400,
      padding: '10px 14px',
      cursor: 'not-allowed',
    },
  },
};

export const copyButtonStyles = {
  color: Color.Primary2Dark,
  padding: '8px',
  borderRadius: '6px',
  '&:hover': {
    backgroundColor: Color.Primary2Main,
  },
};

export const notificationSectionStyles = {
  mt: 3,
  ml: 0,
};

export const emailNotificationContainerStyles = {
  mb: 3,
  display: 'flex',
  flexDirection: 'column',
  ml: 0,
};

export const smsNotificationContainerStyles = {
  mb: 2,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  ml: 0,
};

export const emailCheckboxStyles = {
  mb: 1,
  borderColor: 'primary.main',
  '& .MuiFormControlLabel-label': {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '22px',
  },
  '& .MuiCheckbox-root': {
    color: Color.Grey300,
    '&.Mui-checked': {
      color: Color.Purple600,
    },
  },
};

export const smsCheckboxStyles = {
  '& .MuiFormControlLabel-label': {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '22px',
  },
  '& .MuiCheckbox-root': {
    color: Color.Grey300,
    '&.Mui-checked': {
      color: Color.Purple600,
    },
  },
};

export const notificationInputStyles = {
  background: Color.Grey50,
  borderRadius: '10px',
  ml: 0,
  width: '75%',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    height: '48px',
    width: '100%',
    backgroundColor: Color.Grey50,
    cursor: 'not-allowed',
    '& fieldset': {
      borderColor: Color.Grey300,
    },
    '&:hover fieldset': {
      borderColor: Color.Grey300,
    },
    '&.Mui-focused fieldset': {
      borderColor: Color.Grey300,
    },
  },
  '& .MuiOutlinedInput-input': {
    padding: '8px 14px',
    color: Color.Grey400,
    cursor: 'not-allowed',
  },
};

export const checkboxContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  '& .MuiFormControlLabel-root': {
    margin: 0,
    '& .MuiFormControlLabel-label': {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '22px',
    },
  },
  '& .MuiCheckbox-root': {
    color: Color.Grey300,
    '&.Mui-checked': {
      color: Color.Purple600,
    },
  },
};

export const paymentLinkHeaderStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 8,
};

export const paymentLinkIconButtonStyles = {
  color: Color.PrimaryMain,
  p: 0.5,
  '&:hover': {
    backgroundColor: Color.PrimaryLightest,
  },
};

export const paymentLinkTextStyles = {
  color: Color.PrimaryMain,
  cursor: 'pointer',
  textDecoration: 'underline',
  '&:hover': {
    textDecoration: 'none',
  },
};
